const removeFeatureFlag = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const featureFlagValue = urlParams.get('featureFlags');
    if(featureFlagValue === 'clear') {
        localStorage.removeItem( 'featureFlags');
    }

};

export default removeFeatureFlag;